export const SdwanMobileThree = () => {
    return <div className="px-[18px]">
        <div className="mt-[25px] flex justify-center"><div className="text-[18px] font-bold text-[rgba(51,51,51,1)]">光年KWAN加速引擎 组建全球加速网络</div></div>
        <div className="flex justify-center mt-[10px]">
            <div className="text-[8px] font-regular text-[rgba(51,51,51,1)] text-center">
                采用全自研SD-WAN组网方案，可以在任何地点就近接入用户、接入设备、接入线路
            </div>
        </div>
        <img src="/imgs/kwan/global.png" className="w-[100%] mt-[15px]" />
    </div>
}